module.exports = __webpack_public_path__ + "img/prize-05-icon.f4227e30.png";